// extracted by mini-css-extract-plugin
module.exports = {"loginWithGoogleButton":"LoginWithGoogle_loginWithGoogleButton__3j7-E"};